export type BrandAdNavigationSettings = {
  enableAdLauncher?: boolean;
  enableMetaAds?: boolean;
  creativePerformance?: {
    accountId?: string | null;
  } | null;
};

export function hasCompleteAdLauncherSetup(settings: BrandAdNavigationSettings): boolean {
  return settings.enableAdLauncher === true && Boolean(settings.creativePerformance?.accountId);
}

/** Use the same brand visibility rule for the sidebar and snapshot workers. */
export function shouldShowAdsManager(settings: BrandAdNavigationSettings): boolean {
  return settings.enableMetaAds === true || hasCompleteAdLauncherSetup(settings);
}